<template>
  <v-app id="inspire">


    <v-main>
      <slot />
    </v-main>
    
    <FooterComponent />
    
    
  </v-app>
</template>

<script setup lang="ts">
import FooterComponent from './FooterComponent.vue';
</script>